export enum CategoryType {
    RISK = 'risk',
    VALUE = 'value',
}
